import React from 'react';
import PipelinesTable from './PipelinesTable';

const LeadPipelines = () => {
    return <PipelinesTable stage={"lead"} />
}

export default LeadPipelines;